import { API_PATHS } from "../constants/api-paths";
import { logErrorToNewRelic } from "../utils/logging";
import { type IResponse, encryptedRequest } from "../core/api.client";

export interface ITermInsuranceMiniFormRequest {
  gender: string;
  dateOfBirth: string;
  mobileNo: string;
  emailId: string;
  currentResidentialPinCode: string;
  customertype: string;
  productid: string;
  firstName: string;
  lastName: string;
  fullName: string;
  productName: string;
  categoryName: string;
  premium: string;
  coverage: string;
  tenure: string;
  insuranceCategory: string;
  productInterested: string;
  remarks: string;
  type: string;
}

interface ITermInsuranceMiniFormResponse {
  id: string;
  eventCode: string;
  message: string;
  status: string;
}

export async function postTermInsuranceMiniFormInsert(
  requestBody: ITermInsuranceMiniFormRequest
): Promise<IResponse<ITermInsuranceMiniFormResponse>> {
  try {
    const response = await encryptedRequest<
      ITermInsuranceMiniFormResponse,
      ITermInsuranceMiniFormRequest
    >({
      method: "POST",
      url: API_PATHS.termInsuranceMiniFormInsert,
      data: requestBody,
    });

    if (response.statusCode !== 90) {
      throw new Error(response.message);
    }

    return response;
  } catch (error) {
    logErrorToNewRelic(error as string, {
      errorType: "Error in Term Insurance Mini Form",
    });
    throw error;
  }
}
